export default "__VITE_ASSET__CG$aPlZY__"